/**
 * Строковой шаблонизатор для маски инпута
 * Вызов с параметрами ('9 9 9  9 9 9', '123456') вернет '1 2 3  4 5 6'
 * @param template
 * @param value
 */
export const expandTemplateString = (template: string, value: string) => {
  let count = 0;
  return template.replace(/\d/g, (el) => {
    el = value[count];
    count += 1;
    return el;
  });
};
